<app-mat-spinner-overlay
  *ngIf="showWaitingForDataSpinner != 0"
  [overlay]="true"
>
</app-mat-spinner-overlay>

<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{ anwendungsname }}</h2>
</div>

<div class="spacer"></div>
<div class="container container-border container-size">
  <div class="spacer"></div>

  <h5>
    Klassifizierung des landwirtschaftlichen Betriebes und Ermittlung der
    wirtschaftlichen Betriebsgröße
  </h5>
  <mat-card *ngIf="anzahlBetriebeAnzeigen < betriebList.length">
    Sie haben mehr als drei Dateien erfolgreich hochgeladen und können die
    Ergebnisse nun als ZIP-Datei herunterladen.
  </mat-card>

  <div class="col-md-12" id="content_daten"></div>

  <div class="spacer"></div>
  <mat-card>
    <div class="col-md-12 text-right">
      <button
        (click)="zuMainSeite()"
        mat-raised-button
        color="primary"
        class="custom-btn"
        type="button"
      >
        <fa-icon
          [icon]="faArrowLeft"
          class="ml-1 icon-vertical-align"
        ></fa-icon>
        Zurück
      </button>

      <button
        *ngIf="betriebList.length > 1"
        (click)="onClickDownloadKlassifizierungAlle()"
        mat-raised-button
        color="primary"
        class="custom-btn buttons-right"
        type="button"
      >
        Download Klassifizierung (Alle PDFs in Zip)
        <fa-icon [icon]="faDownload" class="ml-1"></fa-icon>
      </button>
    </div>
  </mat-card>
</div>
